import { Paper, styled } from '@mui/material';

export const StyledReportEmptyDataWrap = styled(Paper)(() => ({
	position: 'relative',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	flexDirection: 'column',
	textAlign: 'center',
	borderRadius: '10px',
	padding: '16px',
	gap: '4px',
	margin: '0 !important',
	minHeight: '150px',
}));

export const StyledReportEmptyDataImage = styled('img')(() => ({
	width: '72px',
}));

export const StyledReportEmptyDataArrowImage = styled('img')({
	maxWidth: '60px',
	position: 'absolute',
	top: '15%',
	right: '15%',
});
